import {Pages} from 'shared/config/model/pages';
import {TARIFFS_ANCHOR_ID} from 'shared/lib/constants';

import React from 'react';
import {useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {Helmet} from 'react-helmet-async';
import PlaceholderGraph from 'rsuite/cjs/Placeholder/PlaceholderGraph';
import {i18n} from '@lingui/core';

import Back from 'shared/ui/icons/General/Back';
import Tariff from 'features/tariff/ui/Tariffs/Tariff/Tariff';
import {ITariff} from 'entities/tariff';
import {userSelector} from 'entities/user';
import useBreakpoint from 'shared/lib/hooks/useBreakpoint';
import {isTranslate} from 'shared/lib/lang';

import {t} from '@lingui/core/macro';

import cn from 'classnames';

import IconsBlock from './IconsBlock/IconsBlock';
import FaqBlock from './FaqBlock/FaqBlock';
import PromoCodeBanner from './PromoCodeBanner/PromoCodeBanner';
import TariffsSlider from './TariffsSlider/TariffsSlider';

import styles from './Tariffs.module.scss';

interface ITariffsProps {
    items: ITariff[];
    isLoading: boolean;
}

const Tariffs: React.FC<ITariffsProps> = ({items, isLoading}) => {
    const user = useSelector(userSelector);
    const navigate = useNavigate();
    const breakpoint = useBreakpoint();

    const userTariff = items.find(tariff => tariff.id === user?.tariff.id);
    const isUserTariffFree = userTariff?.price === 0;

    const otherTariffs = isTranslate()
        ? []
        : items.filter(tariff => tariff.id !== userTariff?.id && !tariff.is_archive);

    const visibleTariffs = userTariff ? [userTariff, ...otherTariffs] : otherTariffs;

    const isWideScreen = breakpoint === 'large' || breakpoint === 'medium';

    const headline = isWideScreen
        ? t`Оформите тариф и откройте больше возможностей мониторинга`
        : t`Платный тариф открывает больше возможностей мониторинга`;

    return (
        <section className={cn(
            styles.section,
            {[styles.enBackground]: isTranslate()},
        )}>
            <Helmet>
                <title>{t`Тарифы`} | {t`Overseer`}</title>
            </Helmet>
            <div className={styles.header}>
                <div className={styles.blockButton}>
                    <div onClick={() => navigate(-1)}>
                        <Back />
                    </div>
                    <span className={styles.title}>{i18n._(Pages.TARIFFS)}</span>
                </div>
                <div className={styles.blockTabs}>
                    <span className={styles.title}>{headline}</span>
                </div>
            </div>
            {
                isLoading
                    ? <PlaceholderGraph height={520} active/>
                    : <div className={styles.tariffs} id={TARIFFS_ANCHOR_ID}>
                        <TariffsSlider>
                            {visibleTariffs.map(tariff => (
                                <Tariff
                                    key={tariff.id}
                                    item={tariff}
                                    user={user}
                                />
                            ))}
                        </TariffsSlider>
                    </div>
            }
            {
                isUserTariffFree && !isTranslate() && <PromoCodeBanner/>
            }
            {
                !isTranslate() &&
                <>
                    <IconsBlock />

                    <div className={styles.faqBlock}>
                        <FaqBlock />
                    </div>
                </>
            }
        </section>
    );
};

export default Tariffs;